<template>
  <span>
    <v-chip
      text-color="white"
      :small="small"
      :color="statusColor(status)">
      <strong>{{ getStatusName(status) }}</strong>
    </v-chip>
  </span>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: 'RewardStatusLabel',
    props: ['status', 'small', 'statuses'],
    data: () => ({
    }),
    computed: {
      ...mapGetters(['getRewardStatusColor', 'getCurrentUser']),
    },
    methods: {
      statusColor (statusId){
        return this.getRewardStatusColor(statusId, this)
      },
      getStatusName: function(id){
        let statuses = this.statuses.filter(status => {
          return status.id == id
        })

        if(statuses.length > 0){
          return statuses[0].name
        }
      }
    },
    mounted() {      
    },
    components: {
    }
  }
</script>
